import React from "react"

const SvgComponent = (props:any) => (
  <svg
    className="animated"
    id="freepik_stories-mobile-marketing"
    viewBox="0 0 500 500"
    {...props}
  >
    <style id="style2">
      {
        "@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes shake{10%,90%{transform:translate3d(-1px,0,0)}20%,80%{transform:translate3d(2px,0,0)}30%,50%,70%{transform:translate3d(-4px,0,0)}40%,60%{transform:translate3d(4px,0,0)}}@keyframes zoomOut{0%{opacity:0;transform:scale(1.5)}to{opacity:1;transform:scale(1)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes heartbeat{0%,30%,40%,60%,to{transform:scale(1)}10%,50%{transform:scale(1.1)}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}svg#freepik_stories-mobile-marketing:not(.animated) .animable{opacity:0}"
      }
    </style>
    <g
      id="freepik--background-complete--inject-10"
      style={{
        transformOrigin: "257.823px 221.27px 0",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp,3s Infinite linear shake",
        animationDelay: "0s,1s"
      }}
      className="animable animator-active"
    >
      <path
        d="M136.31 126.37a34.26 34.26 0 01-34.26-34.26 34.26 34.26 0 0134.26-34.26 34.26 34.26 0 0134.26 34.26 34.26 34.26 0 01-34.26 34.26z"
        style={{
          transformOrigin: "136.31px 92.11px 0"
        }}
        id="el1zfel7m6kt5"
        className="animable"
        fill="#008eff"
        fillOpacity={1}
      />
      <path
        style={{
          transformOrigin: "124.315px 95.935px 0"
        }}
        id="el3lfu8dsi1j1"
        className="animable"
        fill="#fff"
        d="M120.77 84.48H127.86V107.39H120.77z"
      />
      <path
        d="M124.28 81.48a4.23 4.23 0 10-4.19-4.23 4.22 4.22 0 004.19 4.23z"
        style={{
          transformOrigin: "124.32px 77.2501px 0"
        }}
        id="elyniscyqdy88"
        className="animable"
        fill="#fff"
      />
      <path
        d="M139.2 95.36c0-3.22 1.48-5.14 4.32-5.14 2.6 0 3.86 1.84 3.86 5.14v12h7.05V92.88c0-6.14-3.47-9.1-8.33-9.1a8 8 0 00-6.9 3.78v-3.08h-6.81v22.9h6.81z"
        style={{
          transformOrigin: "143.41px 95.5797px 0"
        }}
        id="elqnih85iwaf"
        className="animable"
        fill="#fff"
      />
      <path
        style={{
          transformOrigin: "182.22px 37.155px 0"
        }}
        id="elrqxgifxul8g"
        className="animable"
        fill="#f5f5f5"
        d="M182.22 23.89L186.91 32.46 195.49 37.16 186.91 41.85 182.22 50.42 177.53 41.85 168.95 37.16 177.53 32.46 182.22 23.89z"
      />
      <path
        style={{
          transformOrigin: "377.87px 266.225px 0"
        }}
        id="el63epwuynjae"
        className="animable"
        fill="#ebebeb"
        d="M377.87 256.27L381.39 262.71 387.82 266.22 381.39 269.74 377.87 276.18 374.35 269.74 367.92 266.22 374.35 262.71 377.87 256.27z"
      />
      <path
        style={{
          transformOrigin: "387.82px 229px 0"
        }}
        id="el4tghnsaylue"
        className="animable"
        fill="#e0e0e0"
        d="M387.82 224.51L389.41 227.41 392.31 229 389.41 230.59 387.82 233.49 386.24 230.59 383.33 229 386.24 227.41 387.82 224.51z"
      />
      <path
        style={{
          transformOrigin: "148.71px 31.6px 0"
        }}
        id="el0lg8yafyde5p"
        className="animable"
        fill="#e0e0e0"
        d="M148.71 27.11L150.3 30.02 153.2 31.6 150.3 33.19 148.71 36.09 147.13 33.19 144.22 31.6 147.13 30.02 148.71 27.11z"
      />
      <path
        d="M69.13 296.76a10.39 10.39 0 006.06-9.68c0-5.73-4.45-10.33-9.82-10.29s-9.68 4.73-9.63 10.46a10.34 10.34 0 006.32 9.6C47.12 299.3 48 315.56 48 315.56l35.39-.3s.61-16.45-14.26-18.5z"
        style={{
          transformOrigin: "65.6919px 296.175px 0"
        }}
        id="elbbhzju6ubiw"
        className="animable"
        fill="#e0e0e0"
      />
      <path
        d="M408.64 403.94a5.51 5.51 0 00-10.87.32 5.51 5.51 0 00-10.87-.26 7.43 7.43 0 001.34 5.37 21.83 21.83 0 003.88 4.1c2 1.77 3.81 3.42 5.79 5.18 2-1.78 3.63-3.45 5.59-5.23a21.59 21.59 0 003.85-4.14 7.45 7.45 0 001.29-5.34z"
        style={{
          transformOrigin: "397.772px 409.066px 0"
        }}
        id="elb8jtd08uksk"
        className="animable"
        fill="#ebebeb"
      />
      <path
        d="M431.69 193.15l3.79-.75 6-13.18-1.5-7.57s5.79-1.52 7.07 8.53 1.52 7.38 1.52 7.38 12.45-2.42 13.7-1.55c.91.64 3.7 12.94 5.16 19.62a7.39 7.39 0 01-3.69 8.33 5.19 5.19 0 01-1.31.44c-3.1.62-19.46 1.24-19.46 1.24l-6.55 1.3z"
        style={{
          transformOrigin: "449.673px 194.254px 0"
        }}
        id="elhoohxzgxm2u"
        className="animable"
        fill="#1878dc"
        fillOpacity={1}
      />
      <path
        style={{
          transformOrigin: "427.405px 205.35px 0"
        }}
        id="el38eusaw3swd"
        className="animable"
        fill="#4180db"
        fillOpacity={1}
        d="M420.42 193.22L427.89 218.7 434.39 217.41 429.35 192 420.42 193.22z"
      />
    </g>
    <g
      id="freepik--Floor--inject-10"
      style={{
        transformOrigin: "248.985px 469.32px 0",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomOut",
        animationDelay: "0s"
      }}
      className="animable"
    >
      <path
        d="M470.47 469.32c0 .15-99.17.26-221.47.26s-221.5-.11-221.5-.26 99.15-.26 221.5-.26 221.47.12 221.47.26z"
        style={{
          transformOrigin: "248.985px 469.32px 0"
        }}
        id="el5r9iknxeidm"
        className="animable"
        fill="#263238"
      />
    </g>
    <g
      id="freepik--Icons--inject-10"
      style={{
        transformOrigin: "260.142px 257.296px 0",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight,6s Infinite linear heartbeat",
        animationDelay: "0s,1s"
      }}
      className="animable"
    >
      <path
        d="M393.43 183.15a40.64 40.64 0 01-54.31-18.77 40.64 40.64 0 0118.77-54.31 40.63 40.63 0 0154.31 18.77 40.63 40.63 0 01-18.77 54.31z"
        style={{
          transformOrigin: "375.657px 146.613px 0"
        }}
        id="el4wez6q9j2al"
        className="animable"
        fill="#d7004c"
      />
      <path
        d="M365.62 155.69a1 1 0 00.95-1.23c-.1-.49-.37-1.73-.47-2.24-.14-.71-.31-.9-1-1.22a8 8 0 01-4-4.09c-3.06-6.3-1.09-14.23 6.47-17.9 6.69-3.26 12.36-1 15 4.5 3.49 7.19 3.26 14.8-1.46 17.1a4.29 4.29 0 01-6.27-2.89c-.78-3.52-1-7.63-2.1-9.91-1-2-2.92-3.21-5.18-2.11-2.67 1.3-3.47 5.1-1.67 8.79a10.68 10.68 0 002.71 3.56s2.9 12.88 3.4 15.14c1 4.49 4.22 9 4.53 9.51a.38.38 0 00.67-.15c.09-.44 1.36-5.9.53-10.34-.23-1.26-1.58-7.71-1.58-7.71 1.67 1.23 4.91 1.46 7.6.15 8-3.9 9.9-13.85 5.14-23.63-3.59-7.39-13.21-11.23-22.72-6.6-11.85 5.76-13.69 17.15-10.25 24.23 2.08 4.29 5.53 7.35 9.7 7.04z"
        style={{
          transformOrigin: "372.921px 147.627px 0"
        }}
        id="el0scgxw1wzs0o"
        className="animable"
        fill="#fff"
      />
      <path
        d="M434 297.76a28 28 0 01-16.17-36.18A28 28 0 01454 245.4a28 28 0 0116.17 36.18A28 28 0 01434 297.76z"
        style={{
          transformOrigin: "444px 271.58px 0"
        }}
        id="elg63lp0c5a1o"
        className="animable"
        fill="#00d063"
        fillOpacity={1}
      />
      <path
        d="M458.64 276.34a15.09 15.09 0 00-28.07-11c-.09.2-.17.41-.25.61a14.82 14.82 0 00-.74 8l-5.41 6.53 8.76.5a15.09 15.09 0 0025.58-4.26 3.62 3.62 0 00.13-.38zm-18.72 6.73a12.6 12.6 0 01-5.77-4.44l-5.11-.29 3.15-3.8a12.47 12.47 0 01.37-7.76c.15-.38.32-.76.5-1.12a12.69 12.69 0 0123.52 9.24c-.09.32-.19.63-.31.94a12.65 12.65 0 01-16.35 7.23z"
        style={{
          transformOrigin: "441.808px 271.358px 0"
        }}
        id="elw5d7hx3a5qh"
        className="animable"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M449.8 276.6c-.29-.3-1.66-1.78-1.94-2s-.48-.38-.84-.12-1.33.77-1.61.92-.5.1-.78-.2a10.09 10.09 0 01-2.13-2.77 11 11 0 01-1-3.1c-.06-.42.18-.54.42-.64s.5-.27.75-.4l.19-.12a3.53 3.53 0 00.37-.33.65.65 0 00.21-.61c0-.2-.07-2.16-.1-2.95s-.36-.79-.56-.87-.42-.2-.65-.28a1.37 1.37 0 00-1.09.07 4.16 4.16 0 00-2.3 2.41 4.66 4.66 0 00-.27 1.23 8.26 8.26 0 00.33 2.85c.09.29.94 4.71 3.92 7.43s3.17 2.26 3.83 2.44a3.67 3.67 0 003-.74 3 3 0 00.83-1.55c-.11-.19-.3-.37-.58-.67z"
        style={{
          transformOrigin: "444.418px 271.338px 0"
        }}
        id="elm5tqgbvo4us"
        className="animable"
        fill="#fff"
        fillRule="evenodd"
      />
      <path
        d="M69.63 168.24a21.37 21.37 0 01-21.37-21.37 21.37 21.37 0 0121.37-21.37A21.37 21.37 0 0191 146.87a21.37 21.37 0 01-21.37 21.37z"
        style={{
          transformOrigin: "69.63px 146.87px 0"
        }}
        id="el1uhhii5cd3l"
        className="animable"
        fill="#00a6d7"
        fillOpacity={1}
      />
      <path
        d="M58.25 154a13.3 13.3 0 0020.44-11.8 9.58 9.58 0 002.31-2.39 9.65 9.65 0 01-2.69.74 4.7 4.7 0 002.08-2.55 9.14 9.14 0 01-3 1.13 4.68 4.68 0 00-8 4.27 13.29 13.29 0 01-9.63-4.89 4.69 4.69 0 001.45 6.24 4.6 4.6 0 01-2.12-.58 4.68 4.68 0 003.75 4.64 4.67 4.67 0 01-2.11.08 4.68 4.68 0 004.36 3.24 9.39 9.39 0 01-6.84 1.87z"
        style={{
          transformOrigin: "69.625px 146.847px 0"
        }}
        id="el6qsrmlg2uu6"
        className="animable"
        fill="#fff"
      />
      <path
        d="M108 407.61a36.8 36.8 0 01-44.3-27.27A36.8 36.8 0 0191 336a36.8 36.8 0 0144.33 27.27A36.8 36.8 0 01108 407.61z"
        style={{
          transformOrigin: "99.5142px 371.806px 0"
        }}
        id="elq7rcxglpdlm"
        className="animable"
        fill="url(#linearGradient1118)"
        fillOpacity={1}
      />
      <path
        d="M95.67 355.72c5.24-1.25 5.87-1.38 8-1.78a11.18 11.18 0 013.8-.19 6.29 6.29 0 012.61.93 6.43 6.43 0 012 1.91 11.22 11.22 0 011.54 3.48c.59 2.05.76 2.67 2 7.91s1.37 5.87 1.77 8a10.92 10.92 0 01.19 3.8 6 6 0 01-.93 2.61 6.29 6.29 0 01-1.9 2 11.31 11.31 0 01-3.49 1.54c-2 .59-2.66.76-7.9 2s-5.87 1.38-8 1.78a11 11 0 01-3.81.19 6.2 6.2 0 01-2.61-.93A6.08 6.08 0 0187 387a11.06 11.06 0 01-1.55-3.48c-.58-2.05-.75-2.66-2-7.9s-1.38-5.87-1.78-8a11.52 11.52 0 01-.19-3.81 6.64 6.64 0 012.84-4.61 11.17 11.17 0 013.48-1.55c2-.58 2.67-.75 7.91-2m-.84-3.54c-5.33 1.27-6 1.45-8.07 2.05a14.62 14.62 0 00-4.55 2 10.36 10.36 0 00-4.37 7.1 14.85 14.85 0 00.22 5c.41 2.11.54 2.79 1.81 8.12s1.45 6 2 8.06a14.51 14.51 0 002 4.55 9.91 9.91 0 003.15 3.01 9.8 9.8 0 004 1.43 14.79 14.79 0 005-.22c2.11-.4 2.79-.54 8.12-1.81s6-1.45 8.06-2a15 15 0 004.55-2 9.91 9.91 0 002.94-3.09 10.07 10.07 0 001.44-4 14.84 14.84 0 00-.23-5c-.4-2.12-.54-2.79-1.81-8.12s-1.45-6-2-8.07a15.1 15.1 0 00-2-4.55 9.88 9.88 0 00-3.09-2.93 9.73 9.73 0 00-4-1.44 14.79 14.79 0 00-5 .22c-2.12.41-2.79.54-8.12 1.81"
        style={{
          transformOrigin: "99.5232px 371.815px 0"
        }}
        id="elyu88tga1ap"
        className="animable"
        fill="#fff"
      />
      <path
        d="M97.1 361.73a10.36 10.36 0 1012.48 7.68 10.37 10.37 0 00-12.48-7.68m4 16.63a6.73 6.73 0 115-8.11 6.73 6.73 0 01-5 8.11"
        style={{
          transformOrigin: "99.5013px 371.809px 0"
        }}
        id="el9f8n9a5z9kh"
        className="animable"
        fill="#fff"
      />
      <path
        d="M109.84 358.28a2.42 2.42 0 11-2.92-1.8 2.41 2.41 0 012.92 1.8"
        style={{
          transformOrigin: "107.484px 358.833px 0"
        }}
        id="elwqpz315mnmq"
        className="animable"
        fill="#fff"
      />
      <path
        d="M386.81 375.22a17.16 17.16 0 01-17.17-17.16 17.16 17.16 0 0117.17-17.16A17.16 17.16 0 01404 358.06a17.16 17.16 0 01-17.19 17.16z"
        style={{
          transformOrigin: "386.82px 358.06px 0"
        }}
        id="eloo0lj18ag7n"
        className="animable"
        fill="#36a2ec"
        fillOpacity={1}
      />
      <path
        d="M384.19 368.43h4.18V358h2.91l.32-3.5h-3.23v-2c0-.82.17-1.15 1-1.15h2.27v-3.64h-2.9c-3.11 0-4.51 1.37-4.51 4v2.8H382V358h2.17z"
        style={{
          transformOrigin: "386.82px 358.07px 0"
        }}
        id="elbmyg5qjnuxn"
        className="animable"
        fill="#fff"
      />
    </g>
    <g
      id="freepik--Device--inject-10"
      style={{
        transformOrigin: "259.38px 267.185px 0",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomOut",
        animationDelay: "0s"
      }}
      className="animable"
    >
      <path
        d="M328.27 470.05L190.38 470a30 30 0 01-30-30l.06-345.68a30 30 0 0130.06-30l137.88.08a30 30 0 0130 30l-.06 345.6a30 30 0 01-30.05 30.05z"
        style={{
          transformOrigin: "259.38px 267.185px 0"
        }}
        id="el7hh7mg2eot4"
        className="animable"
        fill="#263238"
      />
      <path
        d="M328.23 76.52h-26.74a6.65 6.65 0 00-6.49 6.76v4.85a6.63 6.63 0 01-6.49 6.78H236.4a6.64 6.64 0 01-6.49-6.79v-4.88a6.66 6.66 0 00-6.49-6.79h-32.81a21 21 0 00-21.05 21l-.07 337.41a21 21 0 0021 21l137.62.08a21 21 0 0021-21l.07-337.42a21 21 0 00-20.95-21z"
        style={{
          transformOrigin: "259.335px 266.195px 0"
        }}
        id="el12l4bkssjru9"
        className="animable"
        fill="#fff"
      />
      <path
        d="M330.24 103.93c0 .09-3.48.19-7.76.22s-7.77 0-7.77-.09 3.47-.2 7.76-.23 7.77.01 7.77.1z"
        style={{
          transformOrigin: "322.475px 103.991px 0"
        }}
        id="el58wxhwq1qd7"
        className="animable"
        fill="#263238"
      />
      <path
        d="M330.27 107.9c0 .09-3.47.19-7.76.23s-7.77 0-7.77-.1 3.48-.19 7.77-.23 7.76.01 7.76.1z"
        style={{
          transformOrigin: "322.505px 107.966px 0"
        }}
        id="el7acbwff6l19"
        className="animable"
        fill="#263238"
      />
      <path
        d="M330.31 111.87c0 .09-3.48.2-7.77.23s-7.76 0-7.77-.1 3.48-.19 7.77-.23 7.77.01 7.77.1z"
        style={{
          transformOrigin: "322.54px 111.934px 0"
        }}
        id="el76hji21oufo"
        className="animable"
        fill="#263238"
      />
      <path
        d="M184 115.75H185.54l4.18-.1-.12.11c0-.92 0-1.93-.05-3v-1.74a1.61 1.61 0 011.4-1.29h2a1.63 1.63 0 011.37 1.61c0 1.42 0 2.89.05 4.42l-.19-.19h5.27l-.2.2c0-2.12 0-4.32-.06-6.57v-1.67a1.67 1.67 0 00-.74-1.24l-2.3-2.28-2.23-2.19-1.07-1.06c-.37-.36-.66-.73-1.09-.82a1.43 1.43 0 00-1.21.23c-.32.27-.66.65-1 1l-1.9 1.91c-1.19 1.23-2.43 2.36-3.33 3.43a3.76 3.76 0 00-.26 2v6.76a5.54 5.54 0 010 .69 5.69 5.69 0 010-.63v-1.89c0-.75 0-1.87-.07-3v-1.9-1a2.18 2.18 0 01.29-1.1c1-1.19 2.14-2.25 3.34-3.52l1.88-1.93c.34-.33.61-.66 1-1a1.79 1.79 0 011.53-.31 2.93 2.93 0 011.27.91l1.08 1.06 2.23 2.19 2.31 2.26a4.61 4.61 0 01.59.64 1.73 1.73 0 01.28.89v1.68c0 2.25 0 4.45.05 6.57v.2H194v-.19-4.42a1.27 1.27 0 00-1.06-1.28h-1.92a1.29 1.29 0 00-1.13 1v4.8h-5.48a2.29 2.29 0 01-.41-.24z"
        style={{
          transformOrigin: "191.915px 107.852px 0"
        }}
        id="eld7jmphlbq6"
        className="animable"
        fill="#263238"
      />
      <path
        d="M275 379.41a8.36 8.36 0 01-1.45.1l-3.94.08c-3.32.05-7.92.08-13 .08s-9.68 0-13-.08l-3.94-.08a8.5 8.5 0 01-1.45-.1 7.36 7.36 0 011.45-.1l3.94-.09c3.32 0 7.92-.07 13-.07s9.67 0 13 .07l3.94.09a7.25 7.25 0 011.45.1z"
        style={{
          transformOrigin: "256.61px 379.41px 0"
        }}
        id="elckj6luy603f"
        className="animable"
        fill="#455a64"
      />
      <path
        d="M332.77 388.45c0 .15-21.17.26-47.28.26s-47.28-.11-47.28-.26 21.17-.26 47.28-.26 47.28.12 47.28.26z"
        style={{
          transformOrigin: "285.49px 388.45px 0"
        }}
        id="elxi7ous8hvg9"
        className="animable"
        fill="#455a64"
      />
      <path
        d="M303.22 397c0 .15-14.55.26-32.5.26s-32.51-.11-32.51-.26 14.55-.26 32.51-.26 32.5.08 32.5.26z"
        style={{
          transformOrigin: "270.715px 397px 0"
        }}
        id="elt2r080lxmc"
        className="animable"
        fill="#455a64"
      />
      <path
        d="M334.64 413.53l-2.94-2.95-2.8 2.79v-8.44h5.73zm-2.94-3.32l.09.09 2.59 2.6v-7.7h-5.21v7.55z"
        style={{
          transformOrigin: "331.77px 409.23px 0"
        }}
        id="elddi4n7cpiwu"
        className="animable"
        fill="#263238"
      />
      <path
        d="M256.41 412.43l-1-.46a2.65 2.65 0 11.8-.58zm-2.41-5.62a2.69 2.69 0 00.05 5.37 2.86 2.86 0 001.29-.41l.77.34-.18-.75a2.68 2.68 0 00-2-4.49z"
        style={{
          transformOrigin: "254.214px 409.62px 0"
        }}
        id="elrpgendq434s"
        className="animable"
        fill="#263238"
      />
      <path
        d="M263.07 412l-1.18-2.9-2.23-2h5.4zm-2.91-4.73l1.9 1.74 1 2.47 1.7-4.25z"
        style={{
          transformOrigin: "262.36px 409.55px 0"
        }}
        id="el8bwgrtuy716"
        className="animable"
        fill="#263238"
      />
      <g id="elrrallpcpfe">
        <path
          style={{
            transformOrigin: "263.54px 408.05px 0"
          }}
          className="animable"
          id="rect45"
          fill="#263238"
          transform="rotate(-33.05)"
          d="M261.78 407.95H265.29999999999995V408.15H261.78z"
        />
      </g>
      <path
        d="M247.9 407.66a1.67 1.67 0 00-3.29.11 1.67 1.67 0 00-3.3-.06 2.27 2.27 0 00.41 1.63 6.6 6.6 0 001.18 1.24c.61.53 1.16 1 1.76 1.56.6-.54 1.1-1.05 1.7-1.59a6.6 6.6 0 001.16-1.26 2.22 2.22 0 00.38-1.63z"
        style={{
          transformOrigin: "244.609px 409.233px 0"
        }}
        id="elix7uufwokw"
        className="animable"
        fill="#d7004c"
      />
      <path
        d="M340.66 421v-.94-2.74c0-2.41 0-6-.05-10.56 0-9.19-.05-22.56-.09-39.33l.17.17-159.91.09.26-.26V421l-.25-.25 114.43.11 33.4.07H340.74h-11.97l-33.35.07-114.6.12h-.26V421v-53.83h.28l159.91.09h.17v.17c0 16.81-.07 30.22-.09 39.44V420.09c0 .62-.17.91-.17.91z"
        style={{
          transformOrigin: "260.74px 394.145px 0"
        }}
        id="el5vex4redqze"
        className="animable"
        fill="#263238"
      />
      <g id="elcccan7u88eo">
        <path
          style={{
            transformOrigin: "209.44px 394.2px 0"
          }}
          className="animable"
          id="rect50"
          fill="#ebebeb"
          transform="rotate(-89.67)"
          d="M191.73 372.05H227.14999999999998V416.35H191.73z"
        />
      </g>
      <path
        d="M231.69 376.62h-12.36l-32-.07.24-.23c-.05 10.55-.11 22.63-.17 35.41.05.07-.49-.49-.26-.26h12.05l11.5.07 20.74.15-.21.22c.1-10.64.19-19.46.26-25.66 0-3.08.07-5.5.09-7.19v-1.9-.67 35.63h-.22l-20.74-.08-11.5-.06h-12.05l-.27-.27c.09-12.79.16-24.87.23-35.41v-.24h.24l32.1.29 9 .12h2.97z"
        style={{
          transformOrigin: "209.24px 394.09px 0"
        }}
        id="elnx0c8rm3ob"
        className="animable"
        fill="#263238"
      />
      <g id="elid04y0mfqn">
        <path
          style={{
            transformOrigin: "209.41px 394.205px 0"
          }}
          className="animable"
          id="rect54"
          fill="#e0e0e0"
          transform="rotate(-89.67)"
          d="M193.93 373.61H224.89000000000001V414.8H193.93z"
        />
      </g>
      <path
        style={{
          transformOrigin: "209.315px 400.1px 0"
        }}
        id="elg4704e22c7t"
        className="animable"
        fill="#f5f5f5"
        d="M188.72 409.56L203.22 390.4 212.06 402.49 218.14 396.09 229.91 409.8 188.72 409.56z"
      />
      <path
        d="M215.93 388.12a3.25 3.25 0 11-3.23-3.26 3.24 3.24 0 013.23 3.26z"
        style={{
          transformOrigin: "212.68px 388.11px 0"
        }}
        id="eldry5l0bx7mi"
        className="animable"
        fill="#f5f5f5"
      />
      <path
        d="M262.09 146.87a1.44 1.44 0 01-.48 0l-1.35.05-5 .09c-4.21 0-10 .07-16.46.07s-12.25 0-16.46-.07l-5-.09-1.36-.05a1.34 1.34 0 01-.47 0 1.74 1.74 0 01.47-.05h1.36l5-.08c4.21-.05 10-.08 16.46-.08s12.25 0 16.46.08l5 .08h1.35a1.87 1.87 0 01.48.05z"
        style={{
          transformOrigin: "238.8px 146.87px 0"
        }}
        id="el0eljliu7xul"
        className="animable"
        fill="#263238"
      />
      <path
        d="M327.53 342.65l-4.36-4.38-4.17 4.15v-12.54h8.52zm-4.36-4.92l.13.13 3.85 3.86v-11.44h-7.76v11.22z"
        style={{
          transformOrigin: "323.265px 336.265px 0"
        }}
        id="elebvmgw7yfh"
        className="animable"
        fill="#263238"
      />
      <path
        d="M216.67 341.33l-2-.91a5.16 5.16 0 111.57-1.13zm-4.77-11.05a5.28 5.28 0 00.09 10.56 5.49 5.49 0 002.54-.8l.09-.05 1.5.67-.34-1.48.07-.07a5.27 5.27 0 00-3.95-8.83z"
        style={{
          transformOrigin: "212.159px 335.805px 0"
        }}
        id="el7m7mad551sf"
        className="animable"
        fill="#263238"
      />
      <path
        d="M229.79 340.46l-2.34-5.71-4.38-4 10.64-.08zm-5.73-9.33l3.74 3.43 2 4.86 3.34-8.36z"
        style={{
          transformOrigin: "228.39px 335.565px 0"
        }}
        id="eltbh0oowx5re"
        className="animable"
        fill="#263238"
      />
      <g id="el48fq85m244x">
        <path
          style={{
            transformOrigin: "230.7px 332.715px 0"
          }}
          className="animable"
          id="rect63"
          fill="#263238"
          transform="rotate(-33.05)"
          d="M227.24 332.52H234.16V332.90999999999997H227.24z"
        />
      </g>
      <path
        d="M199.93 332a3.29 3.29 0 00-6.49.21 3.29 3.29 0 00-6.49-.11 4.45 4.45 0 00.81 3.2 13.51 13.51 0 002.33 2.45c1.19 1 2.28 2 3.47 3.07 1.16-1.06 2.16-2.06 3.33-3.13a13.47 13.47 0 002.29-2.48 4.46 4.46 0 00.75-3.21z"
        style={{
          transformOrigin: "193.445px 335.083px 0"
        }}
        id="elow4y1bi5yrr"
        className="animable"
        fill="#d7004c"
      />
      <circle
        cx={198.96}
        cy={146.87}
        r={7.22}
        style={{
          transformOrigin: "198.96px 146.87px 0"
        }}
        id="elnk6c2tfv06"
        className="animable"
        fill="#ebebeb"
      />
      <path
        d="M324.81 301.25c0 .15-30.26.27-67.58.27s-67.59-.12-67.59-.27 30.26-.26 67.59-.26 67.58.12 67.58.26z"
        style={{
          transformOrigin: "257.225px 301.255px 0"
        }}
        id="elkh8z078ssq"
        className="animable"
        fill="#455a64"
      />
      <path
        d="M324.81 290c0 .14-30.26.26-67.58.26s-67.59-.12-67.59-.26 30.26-.26 67.59-.26 67.58.12 67.58.26z"
        style={{
          transformOrigin: "257.225px 290px 0"
        }}
        id="elje4x94de65"
        className="animable"
        fill="#455a64"
      />
      <path
        d="M263.21 312.66c0 .14-16.47.26-36.78.26s-36.79-.12-36.79-.26 16.47-.26 36.79-.26 36.78.12 36.78.26z"
        style={{
          transformOrigin: "226.425px 312.66px 0"
        }}
        id="el7dywlozloas"
        className="animable"
        fill="#455a64"
      />
      <path
        d="M254.14 435.29a2.88 2.88 0 11-2.86-2.93 2.89 2.89 0 012.86 2.93z"
        style={{
          transformOrigin: "251.26px 435.24px 0"
        }}
        id="elvz9t621odm"
        className="animable"
        fill="#263238"
      />
      <path
        d="M263 435.33a2.87 2.87 0 11-2.86-2.93 2.88 2.88 0 012.86 2.93z"
        style={{
          transformOrigin: "260.131px 435.27px 0"
        }}
        id="els5iz1nfdt1"
        className="animable"
        fill="#263238"
      />
      <path
        d="M271.93 435.37a2.87 2.87 0 11-2.86-2.93 2.89 2.89 0 012.86 2.93z"
        style={{
          transformOrigin: "269.06px 435.31px 0"
        }}
        id="elr1buqeqv7mk"
        className="animable"
        fill="#263238"
      />
      <path
        style={{
          transformOrigin: "261.655px 210.05px 0"
        }}
        id="elrj6nkiip49o"
        className="animable"
        fill="#e0e0e0"
        d="M181.69 161.15H341.62V258.95H181.69z"
      />
      <path
        style={{
          transformOrigin: "262.09px 228.31px 0"
        }}
        id="eljrgpkawfdz"
        className="animable"
        fill="#f5f5f5"
        d="M196.46 258.98L242.28 197.64 270.7 236 289.95 215.48 327.72 258.94 196.46 258.98z"
      />
      <path
        d="M282.74 190.11a10.34 10.34 0 11-10.34-10.33 10.34 10.34 0 0110.34 10.33z"
        style={{
          transformOrigin: "272.4px 190.12px 0"
        }}
        id="eley9ihwyzo9j"
        className="animable"
        fill="#f5f5f5"
      />
      <path
        d="M341.19 349.85c0-2.09-.1-90.44-.24-221.24l.24.24H181.28l.26-.26v221.24l-.22-.21 159.93.21-159.93.22h-.21v-.22c0-61.93 0-138.5-.05-221.24v-.26h160.43v.23l-.12 159.78c0 19.46-.05 34.83-.06 45.35v15.08c0 .7-.12 1.08-.12 1.08z"
        style={{
          transformOrigin: "261.275px 239.19px 0"
        }}
        id="elwsmelld0unb"
        className="animable"
        fill="#263238"
      />
    </g>
    <g
      id="freepik--Megaphone--inject-10"
      style={{
        transformOrigin: "220.559px 289.481px 0",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft,3s Infinite linear shake",
        animationDelay: "0s,1s"
      }}
      className="animable"
    >
      <path
        d="M266 377.3l3.54-11.89c.62-2.58 1.44-5.62 2.54-9.09 1-3.12 3.54-6.4 5.86-8.76 3.61-3.67 5.33-3.69 7.75-5.64.22-.14.47-.35.68-.46a3.81 3.81 0 001.18-1c2.09-2.26.08-5.77-4.17-5.43-3.19.25-8.41 1.16-16.89 9.91-.11.14-.22.25-.32.38-4.45 5.79-8.63-10.73-9.39-16.88a6.43 6.43 0 00-8.71-5l-20.66 9.66a9.67 9.67 0 00-6 .2 6.16 6.16 0 00-3.94 7.29l8.39 33.41-24.61 81.9h53.05z"
        style={{
          transformOrigin: "244.816px 389.446px 0"
        }}
        id="elzht8s7l8oe"
        className="animable"
        fill="#6b361d"
        fillOpacity={1}
      />
      <path
        d="M306.8 302.08l-16.4 32.14-8.2-2.28-41.2 33.53a8.34 8.34 0 01-11.59-1l-15.7-18.23s31.65-13.63 37.5-24.91-.91-13.85-.91-13.85l14.89-16.92z"
        style={{
          transformOrigin: "260.255px 328.958px 0"
        }}
        id="elbinpne8194"
        className="animable"
        fill="#d7004c"
      />
      <path
        d="M285.53 236.44s-24-5.31-57.79-37.79S178.09 123 174 123.24s-22.19-8.17-56.53 66.52-20.81 92-14 91.9 53.22-13.07 82.2-9.78 66.23 18.4 66.23 18.4z"
        style={{
          transformOrigin: "190.284px 206.671px 0"
        }}
        id="elhs63k7i6cj"
        className="animable"
        fill="#d7004c"
      />
      <path
        d="M336.52 277.15l-8.19 15.57-3.67 7a20.32 20.32 0 01-26.49 9l-51.45-17.93 30-68.4 51.4 27.39a20.32 20.32 0 018.4 27.37z"
        style={{
          transformOrigin: "292.789px 266.489px 0"
        }}
        id="elincvxj8tvr8"
        className="animable"
        fill="#d7004c"
      />
      <g id="elx8i43ai83k9">
        <g
          style={{
            transformOrigin: "292.789px 266.489px 0"
          }}
          className="animable"
          id="g84"
          opacity={0.4}
        >
          <path
            d="M336.52 277.15l-8.19 15.57-3.67 7a20.32 20.32 0 01-26.49 9l-51.45-17.93 30-68.4 51.4 27.39a20.32 20.32 0 018.4 27.37z"
            id="elchbyo1y9lhe"
            style={{
              transformOrigin: "292.789px 266.489px 0"
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M120.21 191.12c-18.27 40.46-25.88 76.52-17 80.53s30.91-25.53 49.18-66 25.88-76.51 17-80.53-30.91 25.54-49.18 66z"
        style={{
          transformOrigin: "136.3px 198.384px 0"
        }}
        id="eljiwtsschzo"
        className="animable"
        fill="#d7004c"
      />
      <g id="elhdbpytxismt">
        <g
          style={{
            transformOrigin: "136.3px 198.384px 0"
          }}
          className="animable"
          id="g89"
          opacity={0.5}
        >
          <path
            d="M120.21 191.12c-18.27 40.46-25.88 76.52-17 80.53s30.91-25.53 49.18-66 25.88-76.51 17-80.53-30.91 25.54-49.18 66z"
            id="elb81bt0jn7fp"
            style={{
              transformOrigin: "136.3px 198.384px 0"
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        style={{
          transformOrigin: "336.535px 289.26px 0"
        }}
        id="el53jpu0xefga"
        className="animable"
        fill="#d7004c"
        d="M340.94 299.65L326.99 295.27 335.62 278.87 346.08 285.37 340.94 299.65z"
      />
      <g id="el0ch0d5uex4dg">
        <g
          style={{
            transformOrigin: "331.93px 287.52px 0"
          }}
          className="animable"
          id="g94"
          opacity={0.6}
        >
          <path
            id="el8llyclp8q4f"
            style={{
              transformOrigin: "331.93px 287.52px 0"
            }}
            className="animable"
            d="M335.62 278.87L326.99 295.27 329.86 296.17 336.87 279.64 335.62 278.87z"
          />
        </g>
      </g>
      <path
        d="M326 282.65c-.2.45-7.16-2.25-15.54-6s-15-7.23-14.81-7.68 7.16 2.26 15.55 6.05 15.01 7.18 14.8 7.63z"
        style={{
          transformOrigin: "310.825px 275.81px 0"
        }}
        id="elmgebg5eind"
        className="animable"
        fill="#d7004c"
      />
      <path
        d="M330.3 272.88c-.22.44-6.52-2.21-14.07-5.93s-13.49-7.09-13.27-7.54 6.51 2.21 14.06 5.93 13.5 7.09 13.28 7.54z"
        style={{
          transformOrigin: "316.63px 266.144px 0"
        }}
        id="elgpienomalu"
        className="animable"
        fill="#d7004c"
      />
      <path
        d="M320.6 292.9c-.07.24-1.73-.14-4.37-1-1.32-.41-2.89-.93-4.62-1.52s-3.5-1.53-5.41-2.4c-7.63-3.54-13.46-7-13.27-7.42s6.46 2.29 14 5.8c1.9.86 3.66 1.8 5.32 2.49s3.15 1.3 4.4 1.86c2.5 1.15 4.02 1.95 3.95 2.19z"
        style={{
          transformOrigin: "306.764px 286.744px 0"
        }}
        id="eltza2jwcndn"
        className="animable"
        fill="#d7004c"
      />
      <path
        d="M157.46 182.13s-20.86-12.94-32.27 15.25 10.53 32.82 10.53 32.82a187.63 187.63 0 0021.74-48.07z"
        style={{
          transformOrigin: "139.681px 204.683px 0"
        }}
        id="eleoym26d93j7"
        className="animable"
        fill="#d7004c"
      />
      <g id="el9c67fdrirs5">
        <g
          style={{
            transformOrigin: "149.755px 210.065px 0"
          }}
          className="animable"
          id="g102"
          opacity={0.5}
        >
          <path
            d="M179.65 148.53c.13 0-.17 1.94-.81 5.39s-1.6 8.44-2.94 14.58l-2.9 9.87q-.79 2.65-1.63 5.49l-.85 2.87c-.31 1-.72 1.91-1.08 2.88l-4.71 12.16c-.41 1.06-.83 2.12-1.24 3.19s-1 2.09-1.47 3.15l-3.1 6.4-3.11 6.39c-.53 1-1 2.12-1.57 3.1s-1.17 2-1.74 2.95l-6.65 11.23c-.54.88-1 1.79-1.6 2.63l-1.73 2.45-3.32 4.68-6 8.37c-4 4.83-7.34 8.64-9.64 11.29a32.77 32.77 0 01-3.73 4 32.31 32.31 0 013.2-4.42c2.22-2.83 5.35-6.79 9.19-11.66l5.75-8.43 3.22-4.69c.56-.8 1.12-1.62 1.69-2.45s1-1.74 1.55-2.63L151 226.1l1.71-2.94c.59-1 1-2 1.55-3.08l3.08-6.35c1-2.15 2.07-4.26 3.09-6.35.48-1 1.06-2.06 1.46-3.12l1.25-3.16 4.78-12c.37-1 .79-1.89 1.11-2.85s.59-1.9.88-2.84l1.7-5.43 3.07-9.75 3.47-14.4a32.28 32.28 0 011.5-5.3z"
            id="el5yxdbuyfhvu"
            style={{
              transformOrigin: "149.755px 210.065px 0"
            }}
            className="animable"
          />
        </g>
      </g>
      <g id="el2ydof8bqhjz" fill="#803300">
        <g
          style={{
            transformOrigin: "241.914px 336.713px 0"
          }}
          className="animable"
          id="g106"
          opacity={0.4}
          fill="#803300"
        >
          <path
            d="M218.69 344c1.91 3.46 3.85 7 6.66 9.73S232 358.4 236 358s7.65-3.66 7.69-7.6c1.88 1.41 4.77.65 6.33-1.12s2.07-4.22 2.25-6.57c2.56 1.51 6.12.32 7.83-2.11a10.14 10.14 0 001-8.56 30.17 30.17 0 00-4.11-7.87c2 .16 4.06.3 5.82-.59s3-3.23 1.93-4.91a4.83 4.83 0 00-2.87-1.83c-3.09-1-5.25-1.74-8.47-1.37-.74 0 1.29 8.48-18.88 20.06-11.97 6.85-15.83 8.47-15.83 8.47z"
            id="el7ugfoa7a0ns"
            style={{
              transformOrigin: "241.914px 336.713px 0"
            }}
            className="animable"
            fill="#803300"
          />
        </g>
      </g>
      <path
        d="M264.11 356.2c0 .09-1.35-.17-3.53-.11a20 20 0 00-14.82 7.11c-1.41 1.66-2 2.87-2.13 2.82a3.08 3.08 0 01.39-.88 17.51 17.51 0 011.45-2.18 19 19 0 0115.11-7.24 15.23 15.23 0 012.6.24 2.73 2.73 0 01.93.24z"
        style={{
          transformOrigin: "253.87px 360.87px 0"
        }}
        id="elpkm9w488axj"
        className="animable"
        fill="#eb996e"
      />
      <path
        d="M220 338.59c3.25 3.12 5.47 6.57 8.88 9.71 1.55 1.43 4 4.13 6 4.49s3.4.09 4.22-1.85c.67-1.57-.53-3.72-1.35-5-2.17-3.41-4.25-6.07-5.87-8.72-.77-1.24.22-1.5.58-.92 1.56 1.62 3.9 3 5.3 4.79 1.92 2.41 2.26 5.62 7.28 4.6a4.38 4.38 0 001.86-.77c1.89-1.45 2-4 1.18-6a16.32 16.32 0 00-2.8-4.22c2.14 2.41 4.47 5 7.87 5.22a4.67 4.67 0 004.75-2.57c1-2.28-.43-4.49-1.88-6.27a65.68 65.68 0 00-8.53-8.72 6.53 6.53 0 00-4.14-1.53c-1.76 0-4 .32-5 1.84a6.85 6.85 0 00-1.37 5.23s-4.4-2.23-7.94.1a11.26 11.26 0 00-4.42 6.36z"
        style={{
          transformOrigin: "239.117px 336.878px 0"
        }}
        id="eli299k4fbulb"
        className="animable"
        fill="#803300"
      />
      <path
        d="M243.45 319.87a5.28 5.28 0 01-.62-6c.75-1.47 1.69-2.9 2.65-3.22 4.19-1.41 22.51 1.76 22.34 5.82s-1.51 6-11.44 4.57c-1.75-.25-4.49-.59-4.49-.59l-2.4 3.6z"
        style={{
          transformOrigin: "254.996px 317.18px 0"
        }}
        id="elsip9qah1zna"
        className="animable"
        fill="#803300"
      />
      <path
        d="M246.73 336.89a23.89 23.89 0 00-10.09-9.15 5.82 5.82 0 011.94.68 17.41 17.41 0 017.28 6.6 5.59 5.59 0 01.87 1.87z"
        style={{
          transformOrigin: "241.685px 332.315px 0"
        }}
        id="el1oah1eucyb4"
        className="animable"
        fill="#d45500"
        fillOpacity={1}
      />
      <path
        d="M249.81 324.4c-.09.08-1.3-.9-2.95-1.91a21.46 21.46 0 00-2.14-1.19c-.57-.26-.95-.33-.94-.41s.43-.12 1.06.07a9.7 9.7 0 012.3 1.09c1.69 1.03 2.8 2.24 2.67 2.35z"
        style={{
          transformOrigin: "246.8px 322.614px 0"
        }}
        id="el1beiakg753b"
        className="animable"
        fill="#a40"
      />
      <path
        d="M252.89 320.62a7.83 7.83 0 01-3.53-.4 6.52 6.52 0 01-2.26-1.22c-.5-.43-.71-.78-.66-.83a15 15 0 003.07 1.52 26.31 26.31 0 013.38.93z"
        style={{
          transformOrigin: "249.661px 319.421px 0"
        }}
        id="eljrf020c1xxc"
        className="animable"
        fill="#a40"
      />
      <path
        d="M235.09 341.92a13 13 0 01-1.67-2.17 19.43 19.43 0 00-4.27-4.86 8.59 8.59 0 00-6.06-1.6 10.28 10.28 0 00-2.55.81s.18-.21.59-.46a5.58 5.58 0 011.9-.72 8.54 8.54 0 016.42 1.55 17.32 17.32 0 014.28 5.07 16.28 16.28 0 011.36 2.38z"
        style={{
          transformOrigin: "227.815px 337.365px 0"
        }}
        id="elktaqs723wu9"
        className="animable"
        fill="#803300"
      />
      <path
        d="M249.1 382.42a56 56 0 01-7.48 1.07 54.22 54.22 0 01-7.55.56 56.34 56.34 0 017.49-1.07 56 56 0 017.54-.56z"
        style={{
          transformOrigin: "241.585px 383.235px 0"
        }}
        id="elt3bhox35t4"
        className="animable"
        fill="#eb996e"
      />
    </g>
    <g
      id="freepik--Stars--inject-10"
      style={{
        transformOrigin: "246.36px 191.56px 0",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
        animationDelay: "0s"
      }}
      className="animable"
    >
      <path
        style={{
          transformOrigin: "406.63px 53.035px 0"
        }}
        id="elarc00qwyz9t"
        className="animable"
        fill="#d7004c"
        d="M406.63 49.84L407.76 51.91 409.82 53.04 407.76 54.17 406.63 56.23 405.5 54.17 403.44 53.04 405.5 51.91 406.63 49.84z"
      />
      <path
        style={{
          transformOrigin: "430.235px 104.205px 0"
        }}
        id="elh69jz2rfml"
        className="animable"
        fill="#d7004c"
        d="M430.24 101.01L431.37 103.08 433.43 104.21 431.37 105.34 430.24 107.4 429.11 105.34 427.04 104.21 429.11 103.08 430.24 101.01z"
      />
      <path
        style={{
          transformOrigin: "51.905px 240.725px 0"
        }}
        id="elwbyy8f3s23"
        className="animable"
        fill="#d7004c"
        d="M51.9 237.53L53.03 239.6 55.1 240.73 53.03 241.85 51.9 243.92 50.77 241.85 48.71 240.73 50.77 239.6 51.9 237.53z"
      />
      <path
        style={{
          transformOrigin: "375.665px 69.935px 0"
        }}
        id="ellpj6qmh6l4q"
        className="animable"
        fill="#d7004c"
        d="M375.66 62.56L378.27 67.33 383.04 69.94 378.27 72.54 375.66 77.31 373.06 72.54 368.29 69.94 373.06 67.33 375.66 62.56z"
      />
      <path
        style={{
          transformOrigin: "73.06px 212.455px 0"
        }}
        id="eltzs24tnuk0l"
        className="animable"
        fill="#d7004c"
        d="M73.06 205.1L75.66 209.85 80.42 212.45 75.66 215.06 73.06 219.81 70.46 215.06 65.7 212.45 70.46 209.85 73.06 205.1z"
      />
      <path
        style={{
          transformOrigin: "436.655px 325.92px 0"
        }}
        id="elz1t34c06j8"
        className="animable"
        fill="#d7004c"
        d="M436.66 318.56L439.26 323.32 444.01 325.92 439.26 328.52 436.66 333.28 434.06 328.52 429.3 325.92 434.06 323.32 436.66 318.56z"
      />
    </g>
    <defs id="defs153">
      <linearGradient id="linearGradient1116">
        <stop offset={0} id="stop1112" stopColor="#e7692b" stopOpacity={1} />
        <stop
          offset={1}
          id="stop1114"
          stopColor="#c330e3"
          stopOpacity={0.96354538}
        />
      </linearGradient>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
          id="feMorphology125"
        />
        <feFlood
          floodColor="#32DFEC"
          floodOpacity={1}
          result="PINK"
          id="feFlood127"
        />
        <feComposite
          in="PINK"
          in2="DILATED"
          operator="in"
          result="OUTLINE"
          id="feComposite129"
        />
        <feMerge id="feMerge135">
          <feMergeNode in="OUTLINE" id="feMergeNode131" />
          <feMergeNode in="SourceGraphic" id="feMergeNode133" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
          id="feMorphology138"
        />
        <feFlood
          floodColor="red"
          floodOpacity={0.5}
          result="PINK"
          id="feFlood140"
        />
        <feComposite
          in="PINK"
          in2="DILATED"
          operator="in"
          result="OUTLINE"
          id="feComposite142"
        />
        <feMerge id="feMerge148">
          <feMergeNode in="OUTLINE" id="feMergeNode144" />
          <feMergeNode in="SourceGraphic" id="feMergeNode146" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
          id="feColorMatrix150"
        />
      </filter>
      <linearGradient
        xlinkHref="#linearGradient1116"
        id="linearGradient1118"
        x1={62.69672}
        y1={371.80162}
        x2={136.33168}
        y2={371.80162}
        gradientUnits="userSpaceOnUse"
      />
    </defs>
  </svg>
)

export default SvgComponent
